/**
 * @param {object} config
 * @prop {function} fn - promise to debounce
 * @prop {function} before - fn to run before promise can successfuly be called
 * @prop {any} rejected - obj to pass to promise.reject on debounce
 * @prop {number} delay - how long to debounce
 *
 */
export const debouncePromise = ({ fn, delay, rejected, before }) => {
  let timer = true
  return function() {
    if (timer === true) {
      timer = false
      setTimeout(() => {
        timer = true
      }, delay)
      typeof before === 'function' && before()
      return fn.apply(null, arguments)
    } else {
      return Promise.reject(rejected)
    }
  }
}
